/* Present equivalent scalar metafield values together without changing catalog data. */
(() => {
  const difficultyName = 'filter.p.m.custom.svaerhedsgrad';
  const needleName = 'filter.p.m.custom.pindstorrelse';
  const gaugeName = 'filter.p.m.custom.strikkefasthed';
  const levels = ['begynder', 'nem', 'middel', 'over middel', 'svær'];
  const names = new Set([difficultyName, needleName, gaugeName]);
  function key(name, value) {
    const text = value.trim().toLowerCase().replaceAll('_', ' ').replace(/\s+/g, ' ');
    if (name === difficultyName) return text.replace('svaer', 'svær');
    if (name === gaugeName) {
      const gauge = text.match(/^(\d+(?:[.,]\d+)?)(?:\s+masker\s+pr\s+10\s*cm)?$/);
      return gauge ? gauge[1].replace(',', '.') : text;
    }
    if (/^\d+\s*mm\s*(?:,|og)\s*\d+\s*mm$/.test(text)) return text.match(/\d+/g).sort((a,b)=>Number(a)-Number(b)).join(' + ');
    const number = text.match(/^(\d+(?:[.,]\d+)?)\s*(?:mm)?$/);
    return number ? number[1].replace(',', '.') : text;
  }
  function label(name, value) {
    if (name === difficultyName) {
      const english = ['Beginner', 'Easy', 'Intermediate', 'Advanced', 'Difficult'];
      const index = levels.indexOf(value);
      return document.documentElement.lang.startsWith('en') && index >= 0 ? english[index] : value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (name === gaugeName) return /^\d+(\.\d+)?$/.test(value) ? `${value.replace('.', ',')} m / 10 cm` : value;
    return /^[\d. +]+$/.test(value) ? `${value.replace('.', ',')} mm` : value;
  }
  function enhance() {
    document.querySelectorAll('.js-filter').forEach(detail => {
      const sample = detail.querySelector('input[type="checkbox"]');
      if (!sample || !names.has(sample.name)) return;
      const list = sample.closest('ul');
      if (!list || list.dataset.fkEnhanced) return;
      list.dataset.fkEnhanced = 'true';
      list.classList.add('fk-filter-list');
      const groups = new Map();
      list.querySelectorAll('input[type="checkbox"]').forEach(input => {
        const normalized = key(input.name, input.value);
        const group = groups.get(normalized) || [];
        group.push(input);
        groups.set(normalized, group);
      });
      const sorted = [...groups.entries()].sort(([a], [b]) => sample.name === difficultyName
        ? (levels.indexOf(a) < 0 ? 99 : levels.indexOf(a)) - (levels.indexOf(b) < 0 ? 99 : levels.indexOf(b))
        : a.localeCompare(b, 'da', { numeric: true }));
      sorted.forEach(([normalized, inputs]) => {
        // Prefer an active value so partially selected old URLs remain truthful.
        const primary = inputs.find(i => i.checked) || inputs.find(i => !i.disabled) || inputs[0];
        const row = primary.closest('li');
        const count = inputs.reduce((sum, input) => {
          const text = input.closest('label').querySelector('.facet-checkbox__text')?.textContent || '';
          return sum + Number(text.match(/\((\d+)\)/)?.[1] || 0);
        }, 0);
        primary.fkPeers = inputs;
        primary.disabled = inputs.every(i => i.disabled);
        const wrapper = primary.closest('label');
        wrapper.classList.toggle('disabled', primary.disabled);
        const visible = wrapper.querySelector('.facet-checkbox__text');
        if (visible) visible.textContent = `${label(primary.name, normalized)} (${count})`;
        const accessible = wrapper.querySelector('.visually-hidden');
        if (accessible) accessible.textContent = `${label(primary.name, normalized)} (${count})`;
        row.classList.remove('hidden', 'show-more-item');
        list.append(row);
        inputs.filter(i => i !== primary).forEach(input => {
          const duplicate = input.closest('li');
          duplicate.classList.add('fk-filter-duplicate');
          list.append(duplicate);
        });
      });
      const selected = [...groups.values()].filter(inputs => inputs.some(i=>i.checked)).length;
      const summary = detail.querySelector('.facets__summary');
      const selectedText = summary?.querySelector('.facets__selected');
      if (selectedText) { selectedText.textContent = ` (${selected})`; selectedText.classList.toggle('hidden', selected === 0); }
      if (summary?.hasAttribute('aria-label')) summary.setAttribute('aria-label',summary.getAttribute('aria-label').replace(/\(\d+ /,`(${selected} `));
      detail.querySelector('show-more-button')?.setAttribute('hidden', '');
      if (sample.name === difficultyName && !detail.classList.contains('mobile-facets__details')) detail.open = true;
    });
    // Difficulty is the first filter on both desktop and mobile.
    document.querySelectorAll('.js-filter').forEach(detail => {
      if (!detail.querySelector(`input[name="${difficultyName}"]`)) return;
      const first = [...detail.parentElement.children].find(e => e.classList.contains('js-filter'));
      if (first && first !== detail) first.before(detail);
    });
    // One removable chip per equivalent group; removal clears all spellings.
    document.querySelectorAll('.active-facets').forEach(container => {
      const groups = new Map();
      container.querySelectorAll('facet-remove').forEach(remove => {
        const anchor = remove.querySelector('a');
        if (!anchor || !anchor.classList.contains('active-facets__button')) return;
        const text = anchor.textContent.replace(/\s+/g, ' ').trim();
        const match = text.match(/^(Sværhedsgrad|Difficulty|Pindstørrelse|Strikkefasthed)\s*:\s*([^(:]+)/i);
        if (!match) return;
        const name = /pind/i.test(match[1]) ? needleName : /strikkefasthed/i.test(match[1]) ? gaugeName : difficultyName;
        const value = key(name, match[2].replace(/Fjern filter.*|Remove filter.*/i, '').trim());
        const groupKey = name + ':' + value;
        const prior = groups.get(groupKey);
        if (prior) { remove.hidden = true; return; }
        groups.set(groupKey, remove);
        const url = new URL(anchor.href);
        const retained = url.searchParams.getAll(name).filter(v => key(name, v) !== value);
        url.searchParams.delete(name);
        retained.forEach(v => url.searchParams.append(name, v));
        anchor.href = url.pathname + url.search;
      });
    });
  }
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.fkPeers) return;
    input.fkPeers.forEach(peer => { peer.checked = input.checked; });
  }, true);
  window.FrejaFilters = { enhance };
  enhance();
})();
